// src/ability/ability.ts
import { Ability, AbilityBuilder } from "@casl/ability";
import { UserRole } from "../constants/UserEnums";
import { makeAutoObservable } from "mobx";

interface User {
  userRole?: UserRole;
}

class AbilityStore {
  ability: Ability;

  constructor() {
    this.ability = new Ability([]);
    makeAutoObservable(this);
  }

  defineAbilitiesFor(user: User): void {
    console.log("defineAbilitiesFor: userRole:", user.userRole, "UserRole.ADMIN:", UserRole.ADMIN);
    const { can, cannot, rules } = new AbilityBuilder(Ability);

    const normalizedUserRole = user.userRole ? user.userRole.toLowerCase() : undefined;

    switch (normalizedUserRole) {
      case undefined:
        console.log("Setting abilities for undefined userRole: []");
        break;
      case UserRole.ADMIN:
        console.log("Setting abilities for ADMIN: can access Admin panel");
        can("access", "Admin panel");
        can("read", "User data");
        can("manage", "Users");
        can("manage", "Orders");
        can("manage", "Evaluations");
        break;
      case "uolss":
      case "uolsme":
      case "uolslm":
        console.log("Setting abilities for user role:", normalizedUserRole);
        can("read", "User data");
        can("access", "Verification");
        cannot("access", "Admin panel");
        break;
      default:
        console.log("Setting abilities for default userRole: can read User data");
        can("read", "User data");
        cannot("access", "Admin panel");
    }

    this.ability.update(rules);
    console.log("Updated ability rules:", this.ability.rules);
    console.log("Can access Admin panel:", this.ability.can("access", "Admin panel"));
  }
}

export const abilityStore = new AbilityStore();
export const ability = abilityStore.ability;
export const defineAbilitiesFor = abilityStore.defineAbilitiesFor.bind(abilityStore);